module.exports = __webpack_public_path__ + "img/163144.6e32cafc.jpg";